import { render, staticRenderFns } from "./BookingCalendarWeekDesktop.vue?vue&type=template&id=3bee91e1"
import script from "./BookingCalendarWeekDesktop.vue?vue&type=script&lang=js"
export * from "./BookingCalendarWeekDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports